import { createEnum, requestState } from '../utils/actionTypesHelpers';

export default createEnum(
  {
    get: createEnum(requestState, 'adminUsers.get'),
  },
  'adminUsers',
);
